<template>
  <v-card>
    <v-card-title>
        Adicionar uma nova pergunta
    </v-card-title>
    <v-container flex>
      <v-form lazy-validation v-model="valid" ref="formFaq">
        <v-layout row wrap fill-height justify-space-between>
            <v-flex xs12>
                <v-text-field
                  label="Título"
                  :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                  v-model="dadosPergunta.titulo"
                  required
                >
                </v-text-field>
            </v-flex>
        </v-layout>
            <v-layout row wrap align-center>
                Quem verá:
                <v-spacer></v-spacer>
                <v-checkbox
                    v-model="dadosPergunta.classificacao_posto"
                    label="Posto"
                    color="info"
                    class="shrink mr-3"
                ></v-checkbox>
                <v-checkbox
                    v-model="dadosPergunta.classificacao_cliente"
                    label="Cliente"
                    color="info"
                    class="shrink mr-3"
                ></v-checkbox>
                <v-checkbox
                    v-model="dadosPergunta.classificacao_frentista"
                    label="Frentista"
                    color="info"
                    class="shrink mr-3"
                ></v-checkbox>
                <v-checkbox
                    v-model="dadosPergunta.classificacao_empresa"
                    label="Empresa"
                    color="info"
                    class="shrink mr-3"
                ></v-checkbox>
            </v-layout>
        <v-layout>
            <v-flex xs12>
                <v-textarea
                    v-model="dadosPergunta.conteudo"
                    counter="500"
                    label="Conteúdo"
                    required
                    :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                >
                </v-textarea>
            </v-flex>
        </v-layout>
      </v-form>
    </v-container>
    <v-card-actions>
        <v-btn flat color="info" @click="fechar()">Voltar</v-btn>
        <v-spacer></v-spacer>
        <v-btn flat color="info" @click="inserirPergunta()">Confirmar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { faqDao } from '@/api'

export default {
  data () {
    return {
      valid: false,
      dadosPergunta: {
        titulo: null,
        conteudo: null,
        classificacao_cliente: true,
        classificacao_posto: true,
        classificacao_frentista: true,
        classificacao_empresa: true
      }
    }
  },
  computed: {
    headers () {
      return this.$store.getters.headers
    }
  },
  methods: {
    fechar () {
      this.$refs.formFaq.reset()
      this.$emit('fechar')
    },
    inserirPergunta () {
      if (this.$refs.formFaq.validate()) {
        faqDao.insertFaq(this.dadosPergunta, this.headers)
          .then(response => {
            if (response.ok) {
              this.$emit('info', 'Pergunta adicionada com sucesso')
              this.fechar()
            } else {
              this.$emit('error', 'Não foi possível adicionar sua pergunta')
              this.fechar()
            }
          })
      }
    }
  }
}
</script>
